import { Box, Chip, Paper, Stack, Typography, useTheme } from "@mui/material";
import { tokens } from "../../../theme";

const InventoryTransactionPage = ({ title, step, description }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="24px">
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" gap={2} mb={3}>
        <Box>
          <Typography variant="h3" fontWeight={800} color={colors.grey[100]}>{title}</Typography>
          <Typography mt={1} color={colors.grey[300]}>{description}</Typography>
        </Box>
        <Chip label={`Inventory workflow · Step ${step} of 6`} color="info" />
      </Stack>
      <Paper elevation={0} sx={{ p: 4, borderRadius: "18px", color: colors.grey[100], backgroundColor: colors.primary[400], border: `1px solid ${colors.grey[700]}` }}>
        <Typography variant="h5" fontWeight={700}>{title} workspace</Typography>
        <Typography mt={1.5} color={colors.grey[300]}>
          This transaction screen is ready for its document list, entry form, and posting API.
        </Typography>
      </Paper>
    </Box>
  );
};

export default InventoryTransactionPage;
